import { render, staticRenderFns } from "./pill-cta.vue?vue&type=template&id=a04572a2&lang=pug&"
import script from "./pill-cta.vue?vue&type=script&lang=js&"
export * from "./pill-cta.vue?vue&type=script&lang=js&"
import style0 from "./pill-cta.vue?vue&type=style&index=0&id=a04572a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports